import { axiosInstance as request } from '@api/rest.service'

const api = '/contacts'

/**
 * @description GET /contacts/create
 * @returns {AxiosPromise<any>}
 */
export const GET_CONTACTS_CREATE = () => request.get(`${api}/create`)

/**
 * @description POST /contacts
 * @returns {AxiosPromise<any>}
 */
export const CREATE_CONTACT = payload => request.post(api, payload)

/**
 * @description PUT /contacts/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_CONTACT = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description DELETE /contacts/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_CONTACT = id => request.delete(`${api}/${id}`)
